<h2 mat-dialog-title>{{ 'RESET_PASSWORD' | translate }}</h2>

<mat-dialog-content>
  <p>{{ 'RESET_PASSWORD_WARNING' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="resetPassword('Portal')" [disabled]="resetting()">
    {{ 'RESET_PASSWORD_PORTAL' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="resetPassword('App')" [disabled]="resetting()">
    {{ 'RESET_PASSWORD_APP' | translate }}
  </button>
  <button mat-raised-button mat-dialog-close type="button">
    {{ 'CLOSE' | translate }}
  </button>
</mat-dialog-actions>
